/**
 * Run `fn` once the window has finished loading.
 *
 * These initialisers are called from a `.then()` on the Vue mount promise, and the
 * entry scripts are not parser-deferred, so `load` has often already fired by the
 * time we get here. Registering a plain `load` listener in that case silently never
 * runs. Fall through to an immediate call when the document is already complete.
 */
const onWindowLoad = (fn: () => void) => {
    if (document.readyState === 'complete') {
        fn()
        return
    }

    window.addEventListener('load', fn, { once: true })
}

export const animateSplide = () => {
    onWindowLoad(() => {
        document.querySelectorAll('.splide').forEach(node => {
            new Splide(node, {
                rewind: true,
                drag: false,
                autoplay: false,
                perPage: 1,
                pagination: true,
                gap: '24px'
            }).mount()
        })
    })
}

export const animateSplideDeferred = () => {
    onWindowLoad(() => {
        const el = document.querySelector('.splide-deferred') as HTMLElement | null
        if (!el || typeof Splide === 'undefined') return

        const section = el.closest('section')
        if (!section) return

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    observer.disconnect()
                    el.classList.replace('splide-deferred', 'splide')
                    const opts = JSON.parse(el.dataset.splide || '{}')
                    const splide = new Splide(el, opts)

                    const loadAndPlay = (video: HTMLVideoElement) => {
                        if (!video.src && video.dataset.src) {
                            video.src = video.dataset.src
                        }
                        video.play().catch(() => {})
                    }

                    const playActiveVideo = () => {
                        const activeIndex = splide.index
                        const slides = splide.Components.Slides.get()
                        slides.forEach((item) => {
                            const video = item.slide.querySelector('video') as HTMLVideoElement | null
                            if (!video) return
                            if (item.index === activeIndex) {
                                loadAndPlay(video)
                            } else {
                                video.pause()
                            }
                        })
                    }

                    splide.on('mounted moved', playActiveVideo)
                    splide.mount()

                    // Desktop: play hovered slide, pause all others including active
                    el.querySelectorAll('.splide__slide').forEach((slide) => {
                        slide.addEventListener('mouseenter', () => {
                            el.querySelectorAll('.splide__slide video').forEach((v) => {
                                (v as HTMLVideoElement).pause()
                            })
                            const video = slide.querySelector('video') as HTMLVideoElement | null
                            if (video) loadAndPlay(video)
                        })
                        slide.addEventListener('mouseleave', () => {
                            const video = slide.querySelector('video') as HTMLVideoElement | null
                            if (video) video.pause()
                            playActiveVideo()
                        })
                    })
                }
            })
        }, { rootMargin: '200px' })

        observer.observe(section)
    })
}
// import { gsap } from "gsap"
// import { ScrollTrigger } from "gsap/ScrollTrigger"

// gsap.registerPlugin(ScrollTrigger) //ScrollSmoother

// const checkIframeLoaded = new Promise((resolve) => {
//     setTimeout(() => {
//         resolve(true) 
//     }, 600)
// })

export const animateComponents = () => {
    // window.addEventListener('load', () => {
    //     checkIframeLoaded.then(() => {
    //         //stepper
    //         document.querySelectorAll('.animate-stepper').forEach(el => {
    //             const container = el.querySelector('.animate-stepper-container')
    //             const cards = el.querySelectorAll('.animate-stepper-card')
    //             const photos = gsap.utils.toArray(container?.querySelectorAll('.animate-stepper-image'))
    //             gsap.set(photos, {yPercent: 101})

    //             cards.forEach((card, i) => {
    //                 const headline = card.querySelector('h2')
    //                 ScrollTrigger.create({
    //                     trigger: headline,
    //                     start: "top 80%",
    //                     end: "top 50%",
    //                     animation: gsap.to(photos[i], {yPercent: 0}),
    //                     scrub: true,
    //                 })
    //             })
    //         })

    //         // sticky
    //         document.querySelectorAll('.animate-sticky').forEach(el => {
    //             const container = el?.dataset?.container ? el?.dataset?.container : null
    //             const start = el?.dataset?.start ? el?.dataset?.start : '0'
    //             const end = el?.dataset?.end ? el?.dataset?.end : `100%`

    //             if (container) {
    //                 ScrollTrigger.create({
    //                     trigger: document.getElementById(`#${container}`),
    //                     pin: el,
    //                     start: `-=${start} top`,
    //                     end: `bottom ${end}`,
    //                     scrub: false,
    //                 })
    //             }
    //         })
    //     })
    // })
}